import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import validator from 'validator';

import {
  isLoading,
  showMessageBox,
  getLicenseList,
  getFeaturesList,
  getPermissionList,
  updateLicense,
  deleteLicense,
  getLicenseAssignmentList,
  setQuestion,
} from '../../actions';

import LicenseMaintenance from '../../components/Admin/LicenseMaintenance';

let featureRequiringQty;

const isValidQty = (input) => {
  if (!validator.isInt(String(input), {min: 1, max: 2000000000})) {
    return false;
  }
  return true;
}

const needsQty = (features) => {
  return features.some(f => {
    if (f.hasQuantity && !isValidQty(f.featureQty)) {
      featureRequiringQty = f.featureName;
      return true;
    }
    return false;
  })
}

const getActiveFeatures = (features) => {
  return features.filter(l => l.isSelected)
}

class LicenseMaintenanceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      your: 'mom',
    };
    this.updateLicense  = this.updateLicense.bind(this);
    this.deleteLicense  = this.deleteLicense.bind(this);
  }

  componentWillMount() {
    this.props.getLicenseList();
    // this.props.getFeaturesList();
    this.props.getPermissionList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.method === 'assignments' && nextProps.licenseGUID !== this.props.licenseGUID) {
      nextProps.getLicenseAssignmentList(nextProps.licenseGUID);
    }
  }

  updateLicense(license) {
    let errorMessage = '';

    // validation
    if (!license.name.trim().length) {
      errorMessage = 'Please enter a license name.';
    } else if (!license.sku.trim().length) {
      errorMessage = 'Please enter a SKU.';
    }

    if (errorMessage) {
      return {
        error: true,
        errorMessage,
      };
    }

    this.props.updateLicense(license);

    return {
      error: false,
    };
  }

  deleteLicense() {
    this.props.deleteLicense(this.props.licenseGUID);
  }

  render() {
    return  <LicenseMaintenance
              showMessageBox={this.props.showMessageBox}
              licenses={this.props.licenses}
              assignments={this.props.assignments}
              licenseGUID={this.props.licenseGUID}
              features={this.props.features}
              method={this.props.method}
              updateLicense={this.updateLicense}
              deleteLicense={this.deleteLicense}
              setQuestion={this.props.setQuestion}
              history={this.props.history}
            />
  }
}

export default withRouter(connect(s => s, {
  isLoading,
  showMessageBox,
  getLicenseList,
  getFeaturesList,
  getPermissionList,
  updateLicense,
  deleteLicense,
  getLicenseAssignmentList,
  setQuestion,
})(LicenseMaintenanceContainer));



// WEBPACK FOOTER //
// ./src/containers/Admin/LicenseMaintenance.js